document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-mix-match-bundle]');
  if (!root) return;

  const configEl = root.querySelector('[data-mix-match-bundle-config]');
  const productsEl = root.querySelector('[data-mix-match-bundle-products]');
  const dialog = root.querySelector('[data-mix-match-bundle-dialog]');
  if (!configEl || !productsEl || !dialog) return;

  let config;
  let products;
  try {
    config = JSON.parse(configEl.textContent);
    products = JSON.parse(productsEl.textContent);
  } catch (error) {
    return;
  }

  const productByHandle = products.reduce((map, item) => {
    map[item.handle] = item;
    return map;
  }, {});

  const openButton = root.querySelector('[data-mix-match-bundle-open]');
  const closeButton = dialog.querySelector('[data-mix-match-close]');
  const shippingEl = dialog.querySelector('[data-mix-match-shipping]');
  const progressLabel = dialog.querySelector('[data-mix-match-progress-label]');
  const progressBar = dialog.querySelector('[data-mix-match-progress]');
  const grid = dialog.querySelector('[data-mix-match-grid]');
  const summaryRow = dialog.querySelector('[data-mix-match-summary]');
  const compareEl = dialog.querySelector('[data-mix-match-compare]');
  const priceEl = dialog.querySelector('[data-mix-match-price]');
  const saveEl = dialog.querySelector('[data-mix-match-save]');
  const addButton = dialog.querySelector('[data-mix-match-add]');
  const errorEl = dialog.querySelector('[data-mix-match-error]');

  const minSize = Number(config.minSize || 6);
  const maxSize = Number(config.maxSize || 20);
  let selections = [];
  let lastTrigger = null;
  let adding = false;

  if (dialog.parentElement !== document.body) {
    document.body.appendChild(dialog);
  }

  function formatMoney(cents) {
    const rounded = Math.round(cents);
    const format = config.moneyFormat || '${{amount}}';
    if (rounded % 100 === 0 || format.indexOf('{{amount_no_decimals}}') !== -1) {
      return format
        .replace('{{amount_no_decimals}}', String(Math.round(rounded / 100)))
        .replace('{{amount}}', String(Math.round(rounded / 100)))
        .replace('{{amount_with_comma_separator}}', String(Math.round(rounded / 100)));
    }
    const value = (rounded / 100).toFixed(2);
    return format.replace('{{amount}}', value).replace('{{amount_with_comma_separator}}', value);
  }

  function interpolate(template, vars) {
    return Object.keys(vars).reduce((result, key) => {
      return result.replace(new RegExp('\\[\\[' + key + '\\]\\]', 'g'), String(vars[key]));
    }, template || '');
  }

  function selectedProducts() {
    return selections.map((handle) => productByHandle[handle]).filter(Boolean);
  }

  function discountPercent() {
    const count = selections.length;
    if (count >= Number(config.tier25 || 8)) return Number(config.percent25 || 25);
    if (count >= Number(config.tier20 || 6)) return Number(config.percent20 || 20);
    return 0;
  }

  function selectedSellingPlanId() {
    const sellingPlanInput = document.getElementById('selling_plan');
    const value = sellingPlanInput && String(sellingPlanInput.value || '').trim();
    return value || null;
  }

  function unitPriceCents(item) {
    const planKey = getSelectedPlanKey();
    if (!planKey) return Number(item.price || 0);

    const planId = selectedSellingPlanId() || (item.sellingPlans && item.sellingPlans[planKey]);
    const priceById = item.sellingPlanPriceById || {};
    if (planId != null && priceById[String(planId)] != null) {
      return Number(priceById[String(planId)]);
    }
    if (item.sellingPlanPrices && item.sellingPlanPrices[planKey] != null) {
      return Number(item.sellingPlanPrices[planKey]);
    }
    return Number(item.price || 0);
  }

  function compareCents() {
    return selectedProducts().reduce((sum, item) => sum + unitPriceCents(item), 0);
  }

  function saveCents() {
    const percent = discountPercent();
    if (percent <= 0) return 0;
    return selectedProducts().reduce((sum, item) => {
      return sum + Math.floor((unitPriceCents(item) * percent) / 100);
    }, 0);
  }

  function saleCents() {
    return Math.max(compareCents() - saveCents(), 0);
  }

  function scentCount(handle) {
    return selections.filter((item) => item === handle).length;
  }

  function remainingToMin() {
    return Math.max(minSize - selections.length, 0);
  }

  function renderGrid() {
    if (!grid) return;
    const room = maxSize - selections.length;
    grid.querySelectorAll('[data-scent-handle]').forEach((card) => {
      const handle = card.getAttribute('data-scent-handle');
      const count = scentCount(handle);
      const selected = count > 0;
      const badge = card.querySelector('[data-scent-badge]');
      const qtyWrap = card.querySelector('[data-scent-qty]');
      const qtyValue = card.querySelector('[data-scent-qty-value]');
      const plusBtn = card.querySelector('[data-scent-qty-plus]');
      card.classList.toggle('is-selected', selected);
      const pick = card.querySelector('[data-scent-pick]');
      if (pick) pick.setAttribute('aria-pressed', selected ? 'true' : 'false');
      if (badge) {
        if (selected) {
          badge.hidden = false;
          badge.textContent = count > 1 ? '×' + count : '1';
        } else {
          badge.hidden = true;
          badge.textContent = '';
        }
      }
      if (qtyWrap) qtyWrap.hidden = !selected;
      if (qtyValue) qtyValue.textContent = String(count || 1);
      if (plusBtn) plusBtn.disabled = room <= 0;
    });
  }

  function renderSummary() {
    if (!summaryRow) return;
    summaryRow.replaceChildren();
    const remaining = remainingToMin();

    selections.forEach((handle, index) => {
      const item = productByHandle[handle];
      if (!item) return;
      if (index > 0) {
        const plus = document.createElement('span');
        plus.className = 'mix-match__summary-plus';
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        summaryRow.appendChild(plus);
      }
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'mix-match__summary-remove';
      remove.setAttribute(
        'aria-label',
        interpolate(config.translations.removeProduct, { name: item.title })
      );
      remove.addEventListener('click', () => {
        selections.splice(index, 1);
        render();
      });
      const img = document.createElement('img');
      img.className = 'mix-match__summary-thumb';
      img.src = item.image;
      img.alt = item.title;
      img.width = 36;
      img.height = 36;
      remove.appendChild(img);
      summaryRow.appendChild(remove);
    });

    if (remaining > 0) {
      if (selections.length > 0) {
        const plus = document.createElement('span');
        plus.className = 'mix-match__summary-plus';
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        summaryRow.appendChild(plus);
      }
      const empty = document.createElement('span');
      empty.className = 'mix-match__summary-empty';
      empty.textContent = interpolate(config.translations.addMore, { count: remaining });
      summaryRow.appendChild(empty);
    }
  }

  function renderTotals() {
    const compare = compareCents();
    const sale = saleCents();
    const save = saveCents();
    const percent = discountPercent();
    if (compareEl) {
      compareEl.textContent = formatMoney(compare);
      compareEl.hidden = percent <= 0 || compare <= 0;
    }
    if (priceEl) priceEl.textContent = formatMoney(percent > 0 ? sale : compare);
    if (saveEl) {
      if (percent > 0 && save > 0) {
        saveEl.hidden = false;
        saveEl.textContent = interpolate(config.translations.youSave, {
          amount: formatMoney(save),
          percent: percent,
        });
      } else {
        saveEl.hidden = true;
        saveEl.textContent = '';
      }
    }
  }

  function progressGoal() {
    if (selections.length >= Number(config.tier25 || 8)) return Math.max(selections.length, Number(config.tier25 || 8));
    if (selections.length >= Number(config.tier20 || 6)) return Number(config.tier25 || 8);
    return minSize;
  }

  function renderProgress() {
    const selected = selections.length;
    const total = progressGoal();
    const percent = discountPercent();
    if (progressLabel) {
      if (selected < minSize) {
        progressLabel.textContent = interpolate(config.translations.addMoreTier, {
          count: remainingToMin(),
          percent: config.percent20 || 20,
        });
      } else if (selected < Number(config.tier25 || 8)) {
        progressLabel.textContent = interpolate(config.translations.addMoreTier, {
          count: Number(config.tier25 || 8) - selected,
          percent: config.percent25 || 25,
        });
      } else {
        progressLabel.textContent = interpolate(config.translations.tierUnlocked, { percent: percent });
      }
    }
    if (progressBar) {
      progressBar.max = total;
      progressBar.value = selected;
    }
  }

  function renderHeader() {
    if (shippingEl) shippingEl.hidden = selections.length < minSize;
    if (addButton) {
      addButton.textContent = config.translations.addBundle;
      addButton.disabled = selections.length < minSize || adding;
    }
  }

  function render() {
    renderHeader();
    renderProgress();
    renderGrid();
    renderSummary();
    renderTotals();
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  function lockPageScroll() {
    const state = window.__mixMatchScrollLock || { count: 0, y: 0 };
    window.__mixMatchScrollLock = state;
    state.count += 1;
    if (state.count > 1) return;
    state.y = window.scrollY || document.documentElement.scrollTop || 0;
    const body = document.body;
    body.style.position = 'fixed';
    body.style.top = '-' + state.y + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    document.documentElement.classList.add('mix-match-scroll-lock');
  }

  function unlockPageScroll() {
    const state = window.__mixMatchScrollLock;
    if (!state || state.count === 0) return;
    state.count -= 1;
    if (state.count > 0) return;
    const body = document.body;
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.style.overflow = '';
    document.documentElement.classList.remove('mix-match-scroll-lock');
    window.scrollTo(0, state.y);
  }

  function openModal(trigger) {
    lastTrigger = trigger || null;
    selections = [];
    render();
    lockPageScroll();
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    if (closeButton) closeButton.focus();
  }

  function closeModal() {
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
      return;
    }
    dialog.removeAttribute('open');
    onDialogClose();
  }

  function isBackdropClick(event) {
    if (event.target === dialog) return true;
    const rect = dialog.getBoundingClientRect();
    return (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    );
  }

  function onDialogClose() {
    unlockPageScroll();
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  }

  function addProduct(handle) {
    const item = productByHandle[handle];
    if (!item || !item.available) return;
    if (selections.length >= maxSize) return;
    selections.push(handle);
    render();
  }

  function removeProduct(handle) {
    const index = selections.lastIndexOf(handle);
    if (index < 0) return;
    selections.splice(index, 1);
    render();
  }

  function clearProduct(handle) {
    selections = selections.filter((item) => item !== handle);
    render();
  }

  function getSelectedPlanKey() {
    const oneTimeActive = document.querySelector(
      '.product-subscription-bundles .product-subscription__item[data-place="0"].product-subscription__item--active'
    );
    if (oneTimeActive) return null;

    const subscribeActive = document.querySelector(
      '.product-subscription-bundles .subscription-collapsable-trigger.product-subscription__item--active'
    );
    const bundleFrequency = document.getElementById('bundle-delivery-frequency');
    if (subscribeActive && bundleFrequency) {
      const bundleOption = bundleFrequency.options[bundleFrequency.selectedIndex];
      if (bundleOption && bundleOption.getAttribute('data-place')) {
        return String(bundleOption.getAttribute('data-place'));
      }
    }
    const bundlePlanActive = document.querySelector(
      '.product-subscription-bundles .product-subscription-options__collapsable .product-subscription__item--active[data-place]'
    );
    if (bundlePlanActive && bundlePlanActive.getAttribute('data-place') !== '0') {
      return String(bundlePlanActive.getAttribute('data-place'));
    }
    if (subscribeActive) return '1';

    const sellingPlanInput = document.getElementById('selling_plan');
    if (!sellingPlanInput || !String(sellingPlanInput.value || '').trim()) return null;

    const pdpFrequency = document.getElementById('pdp-delivery-frequency');
    const pdpWidget = document.querySelector('.pdp-subscription-element');
    if (pdpFrequency && pdpWidget && window.getComputedStyle(pdpWidget).display !== 'none') {
      const pdpOption = pdpFrequency.options[pdpFrequency.selectedIndex];
      if (pdpOption && pdpOption.getAttribute('data-place')) {
        return String(pdpOption.getAttribute('data-place'));
      }
    }

    const cycleSelect = document.getElementById('sel_delivery_cycle');
    if (cycleSelect && cycleSelect.value && /^[1-3]$/.test(String(cycleSelect.value))) {
      return String(cycleSelect.value);
    }

    const pdpActive = document.querySelector(
      '.product-subscription-pdp .product-subscription-options__collapsable .product-subscription__item--active'
    );
    if (pdpActive && pdpActive.getAttribute('data-place') && pdpActive.getAttribute('data-place') !== '0') {
      return String(pdpActive.getAttribute('data-place'));
    }

    const caseAActive = document.querySelector(
      '.product-subscription-wrapper.case-a .product-subscription__item--active[data-place]'
    );
    if (caseAActive && caseAActive.getAttribute('data-place') !== '0') {
      return String(caseAActive.getAttribute('data-place'));
    }

    return '1';
  }

  function sellingPlanForProduct(item, planKey) {
    if (!item || !planKey || !item.sellingPlans) return null;
    const planId = item.sellingPlans[planKey];
    if (!planId) return null;
    const numeric = Number(planId);
    return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
  }

  function buildCartItems() {
    const qtyByVariant = {};
    const productByVariant = {};
    selectedProducts().forEach((item) => {
      qtyByVariant[item.variantId] = (qtyByVariant[item.variantId] || 0) + 1;
      productByVariant[item.variantId] = item;
    });
    const packId = 'mmb-' + Date.now();
    const packLabel = interpolate(config.translations.packProperty, { size: selections.length });
    const planKey = getSelectedPlanKey();
    return Object.keys(qtyByVariant).map((variantId) => {
      const item = {
        id: Number(variantId),
        quantity: qtyByVariant[variantId],
        properties: {
          _mix_match_bundle: 'true',
          _mix_match_qty: String(selections.length),
          _bundle_id: packId,
          Pack: packLabel,
        },
      };
      const sellingPlan = sellingPlanForProduct(productByVariant[variantId], planKey);
      if (sellingPlan) item.selling_plan = sellingPlan;
      return item;
    });
  }

  async function addBundleToCart() {
    if (adding || selections.length < minSize) return;
    adding = true;
    addButton.disabled = true;
    addButton.textContent = config.translations.adding;
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }

    try {
      const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: buildCartItems() }),
      });

      if (!response.ok) {
        throw new Error('add_failed');
      }

      closeModal();
      if (window.robustCart) {
        window.robustCart.refreshCart();
        window.robustCart.openCart();
      } else {
        window.location.href = '/cart';
      }
    } catch (error) {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = config.translations.error;
      }
    } finally {
      adding = false;
      renderHeader();
    }
  }

  if (openButton) {
    openButton.addEventListener('click', () => {
      openModal(openButton);
    });
  }

  if (grid) {
    grid.addEventListener('click', (event) => {
      const card = event.target.closest('[data-scent-handle]');
      if (!card || card.hasAttribute('data-scent-unavailable')) return;
      const handle = card.getAttribute('data-scent-handle');
      if (event.target.closest('[data-scent-qty-plus]')) {
        addProduct(handle);
        return;
      }
      if (event.target.closest('[data-scent-qty-minus]')) {
        removeProduct(handle);
        return;
      }
      if (scentCount(handle) > 0) {
        clearProduct(handle);
        return;
      }
      addProduct(handle);
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeModal();
    });
  }

  let sheetTouchY = 0;
  dialog.addEventListener(
    'touchstart',
    (event) => {
      if (event.touches.length) sheetTouchY = event.touches[0].clientY;
    },
    { passive: true }
  );
  dialog.addEventListener(
    'touchmove',
    (event) => {
      const scroller = dialog.querySelector('.mix-match__dialog-body');
      const touch = event.touches[0];
      if (!touch) return;
      if (!scroller || !scroller.contains(event.target)) {
        event.preventDefault();
        return;
      }
      const delta = touch.clientY - sheetTouchY;
      const atTop = scroller.scrollTop <= 0;
      const atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;
      if ((atTop && delta > 0) || (atBottom && delta < 0)) event.preventDefault();
    },
    { passive: false }
  );

  dialog.addEventListener('click', (event) => {
    if (isBackdropClick(event)) closeModal();
  });

  dialog.addEventListener('close', onDialogClose);
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeModal();
  });

  if (addButton) {
    addButton.addEventListener('click', () => {
      addBundleToCart();
    });
  }

  document.addEventListener('click', (event) => {
    if (!dialog.open) return;
    if (!event.target.closest('.product-subscription, .product-subscription-bundles, .product-subscription-pdp')) {
      return;
    }
    window.setTimeout(render, 0);
  });
});
